import React from "react";
import PropTypes from "prop-types";
import { Descriptions, Modal, Select, Icon, message, Table, Row, Col, Tooltip, Upload, Button, Tag, Spin, Menu, Dropdown, Card, Input, DatePicker, Switch} from "antd";
import { Table as TableComponent } from "components";

// import { PermissionContextManager } from "hocs";
import "styles/case-details-summary.css";
import { formatCurrency } from "utilities/currency";
import { CASE_CATEGORY_TYPES, PRIMARY_LANGUAGE, SECONDARY_LANGUAGE, KYC_ENUM, TL_PRODUCT_TYPE, DB_TAGGING, CPV_STATUS, FTR_CATEGORY, BUSINESS_PRODUCT_TYPE, PROGRAM_TYPE_NEW, CASE_CATEGORY, BOOLEAN_OPTIONS, SELLER_HOLD_REASONS, CONSTITUTION_TYPES, TNCCredit } from "constants/enums";
import { CaseService, CompanyService } from "../../services";
import { D2R_LIMIT_COLUMNS, LIMIT_INFO_COLUMNS, PORTFOLIO_COLUMNS } from "../../constants/table-columns";
import companyService from "../../services/company-service";
import { DocumentUploadModal } from "../../components/document-upload-modal";
import { List, OrderedMap } from "immutable";
import { getAuthToken } from "../../utils";
import { AUTHORITY_APPROVAL_STAGE_ID } from "constants/index";
import { RECOURSE_STRUCTURE, STATE_STATUS } from "../../constants";
import moment from "moment";
import { getKeyByValue } from "../../components/helper";
import PDDeclarationForm from "./pd-declaration-form";

// import { ProceedChecklist } from "hocs";
const { Option } = Select;
const Description = Descriptions.Item;

class CaseDetailsSummary extends React.Component {

    state = {
        defaultAsmValue: null,
        asmModal: false,
        asmId: null,
        updateDisable: true,
        defaultIspValue: null,
        ispModal: false,
        ispId: null,
        getBuyerExposureDataV2: [],
        kycValue: null,
        enum_value: null,
        uploadKYCDocumentLoader: false,
        approverDetails: [],
        approverDetailsV2: {},
        isApproved: {},
        loading: false,
        businessProductTypeLoader: false,
        programTypeLoader: false,
        industryModal: false,
        anchorModal: false,
        industryAnchorOptions: [],
        selectedIndustryVal: null,
        selectedAnchorVal: null,
        insuranceAttached: this.props.data.get('is_insurance_mandatory') ?? false,
        caseCategory: 0,
        growthPlanText: this.props.data.get('growth_plan_parameter'),
        growthPlan: {
            aum: "",
            noOfRTs: "",
            timeline: null
        },
        isTNCCreditModalVisible: false,
        tncCredit: {
            deviationTag: null,
            creditRemark: "",
            postSanctionRemark: "",
        },
        showPDDeclarationform : false,
        caseJsonData : {},
        caseDetailUpdateLoader: false
    }

    fetchApprovalDetails = () => {
        CaseService.getApprovalDetails(this.props.caseId)
            .then(({ data }) => {
                let obj = {};
                data.map(_ => {
                    obj[_.name] = _
                })
                this.setState({
                    approverDetails: data,
                    approverDetailsV2: obj
                })

            })
    }

    caseJsonDataFetch = () => {
        CaseService.getCaseJsonData(this.props.caseId)
            .then(({data}) => {
                this.setState({
                    caseJsonData: data
                })
            })
    }

    componentDidMount() {
        this.caseJsonDataFetch();
        if (this.props.stageId == AUTHORITY_APPROVAL_STAGE_ID) {
            this.fetchApprovalDetails();
        }

        this.handleFilesFetch();
        // CompanyService.getBuyerExposure(this.props.caseId).then(res => {
        //     const data = res.data?.message;
        //     const objectKeys = Object.keys(data);
        //     const objectItemKeys = data[objectKeys[0]];
        //     let tableData = [];
        //     Object.keys(objectItemKeys).map(_ => {
        //         let eachItem = objectKeys.map(dataKey => {
        //             return {
        //                 [dataKey]: data[dataKey][_]
        //             };
        //         });
        //         tableData.push({
        //             "name": _.split("_").join(" ").replace(/\b\w/g, function (m) { return m.toUpperCase(); }),
        //             ...Object.assign({}, ...eachItem),
        //         });
        //     });
        //     this.setState({
        //         getBuyerExposureDataV2: Object.entries(data).map(([key, value]) => ({
        //             ...value,
        //             type_2: key
        //         }))
        //     });
        // })
        //     .catch(res => {
        //         console.log("inside catch", res, res && Object.values(res)[0]);
        //     });


        CaseService.getCaseCategoryTag(this.props.caseId).then((res) => {
            if (res.data && res.data.case_category !== undefined) {
                this.setState({
                    caseCategory: res.data.case_category,
                });
            }
        })
            .catch((error) => {
                console.log("error message:", error.message);
            })
    }

    getValue = val => {
        return (
            <React.Fragment>
                <span>{val && val.split("|")[0]}</span>
                <span style={{
                    color: "#f9f9f9",
                }}>{` (${val && val.split("|")[1]})`}</span>
            </React.Fragment>
        );
    }
    getValueAnchor = (tooltipTitle) => {
        let tooltipList;
        let hoverTitle = tooltipTitle;
        if (this.props.caseId === 130090) {
            tooltipList = tooltipTitle.split(",").map(item =>
                item.replace(/\s*\([^)]*\)/g, '').replace(/\d+$/, '').trim()
            );
            hoverTitle = '';
        } else {
            tooltipList = tooltipTitle.split(",").map(item => item.trim());
        }

        return (
            <React.Fragment>
                <span title={hoverTitle}>
                    <div>
                        {tooltipList.map((_, index) => (
                            <div key={index}>{_}</div>
                        ))}
                    </div>
                </span>
            </React.Fragment>
        );
    }
    getValueSeller = (tooltipTitle) => {
        let tooltipList;
        let hoverTitle = tooltipTitle;
        if (this.props.caseId === 130090) {
            tooltipList = tooltipTitle.split(",").map(item =>
                item.replace(/\s*\([^)]*\)/g, '').replace(/\d+$/, '').trim()
            );
            hoverTitle = '';
        } else {
            tooltipList = tooltipTitle.split(",").map(item => item.trim());
        }
        return (
            <React.Fragment>
                <span title={hoverTitle}>

                    <div>
                        {tooltipList.map((_, index) => (
                            <div key={index}>{_}</div>
                        ))}
                    </div>
                </span>
            </React.Fragment>
        );
    }

    openAsmEdit = () => {
        this.setState({
            // defaultAsmValue: this.props.sales_manager_users.filter(item => item.id==this.props.asm_data.id)[0].full_name,
            asmModal: true
        });
    }

    openIndustryEdit = () => {
        this.setState({
            industryModal: true,
            industryAnchorOptions: []
        });
    }

    openAnchorEdit = () => {
        this.setState({
            anchorModal: true,
            industryAnchorOptions: []
        });
    }

    openIspEdit = () => {
        this.setState({
            defaultIspValue: this.props.inside_sales_persons.filter(item => item.id == this.props.isp_data.id)[0]?.full_name,
            ispModal: true
        });
    }

    onAsmChange = (val) => {
        this.setState({
            asmId: val,
            updateDisable: false
        });
    }

    onIspChange = (val) => {
        this.setState({
            ispId: val,
            updateDisable: false
        });
    }

    onKycChange = (val) => {
        this.setState({
            showDocumentUplaod: true,
            enum_value: val
        })

    }
    onInsuranceChange = (val) => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailV2(this.props.caseId, { 'is_insurance_mandatory': val })
            .then((resp) => {
                loadingMessage();
                this.setState({
                    insuranceAttached: val,
                })
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                loadingMessage();
                message.error("Failed to update insurance status. Please try again.");
                this.setState({
                    insuranceAttached: this.state.insuranceAttached,
                })
            })

    }

    onSubmitKycChange = (files) => {
        this.setState({
            uploadKYCDocumentLoader: true
        })
        const body = {
            case_id: this.props.caseId,
            enum_value: this.state.enum_value,
        };
        const formData = new FormData();

        for (const key in body) {
            formData.append(key, body[key]);
        }
        files?.map(_ => {
            formData.append("kyc_documents", _);
        });
        this.state.enum_value && companyService.updateKycVal(formData).then(res => {
            if (res.status === 200) {
                message.success(res && res.data && res.data.message || "Value Updated Successfully")
                this.handleFilesFetch();
                this.setState({
                    kycValue: this.state.enum_value,
                    uploadKYCDocumentLoader: false,
                    showDocumentUplaod: false
                })
            }

        }).catch((err) => {
            this.setState({
                uploadKYCDocumentLoader: false,
                showDocumentUplaod: false
            });
        });
    }

    handleFilesFetch = () => {
        this.props.fetchCompanyDocuments(
            this.props.caseId,
            this.props.companyId
        );
    }

    onAsmUpdate = () => {
        CompanyService.updateSMList(this.props.caseId, this.state.asmId).then(() => {
            message.success("Updated successfully!");
            this.props.callAsmList();
            this.setState({
                asmModal: false,
                updateDisable: true
            });
        }).catch((err) => {
            message.error("Request Failed!");
            console.log("error", err);
        });
    }

    onIndustryUpdate = () => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailV2(this.props.caseId, { "reporting_industry": this.state.selectedIndustryVal }).then((res) => {
            if (res.status === 200) {
                message.success("Updated successfully!");
                this.props.fetchCaseDetail(this.props.caseId);
                loadingMessage();
                this.setState({
                    industryModal: false,
                    updateDisable: true,
                    selectedIndustryVal: res?.data?.reporting_industry?.name
                });
            }
        }).catch((err) => {
            message.error("Request Failed!");
            loadingMessage();
            console.log("error", err);
        });
    }

    onIndustryChange = (search) => {
        const loadingMessage = message.loading("Fetching data...", 0);
        const is_reporting_industry = true;
        CompanyService.industryTypeList(search, is_reporting_industry)
            .then((res) => {
                loadingMessage();
                this.setState({
                    industryAnchorOptions: res.data?.results,
                });
            })
            .catch((err) => {
                loadingMessage();
                message.error("Request Failed!");
                console.log("error", err);
            });
    };

    onAnchorUpdate = () => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailV2(this.props.caseId, { "reporting_anchor": this.state.selectedAnchorVal }).then((res) => {
            if (res.status === 200) {
                message.success("Updated successfully!");
                this.props.fetchCaseDetail(this.props.caseId);
                loadingMessage();
                this.setState({
                    anchorModal: false,
                    updateDisable: true,
                    selectedAnchorVal: res?.data?.reporting_anchor?.name
                });
            }
        }).catch((err) => {
            message.error("Request Failed!");
            loadingMessage();
            console.log("error", err);
        });
    }

    onAnchorChange = (search) => {
        const loadingMessage = message.loading("Fetching data...", 0);
        const is_reporting_anchor = true;
        CompanyService.getCompanyProfiles(1, search, [], is_reporting_anchor)
            .then((res) => {
                loadingMessage();
                this.setState({
                    industryAnchorOptions: res.data?.results,
                });
            })
            .catch((err) => {
                loadingMessage();
                message.error("Request Failed!");
                console.log("error", err);
            });
    };

    onIspUpdate = () => {
        CompanyService.updateISPList(this.props.caseId, this.state.ispId).then(() => {
            message.success("Updated successfully!");
            this.props.callISPList();
            this.setState({
                ispModal: false,
                updateDisable: true
            });
        }).catch((err) => {
            message.error("Request Failed!");
            console.log("error", err);
        });
    }
    columns = [
        {
            title: "",
            dataIndex: "name",
            key: "name",
            width: "50%",
        },
        {
            title: "Case",
            dataIndex: "case",
            key: "case",
            render: (_) => isNaN(Number(_)) ? _ : formatCurrency(_),
            align: "center"
        },
        {
            title: "Buyer",
            dataIndex: "buyer",
            key: "buyer",
            render: (_) => isNaN(Number(_)) ? _ : formatCurrency(_),
            align: "center"

        },
    ];

    onChangeBusinessProductType = (_) => {
        this.setState({
            businessProductType: _,
            businessProductTypeLoader: true
        })

        CaseService.updateCaseDetailV2(this.props.caseId, { 'business_product_type': Number(_) })
            .then((resp) => {
                this.setState({
                    businessProductType: null,
                    businessProductTypeLoader: false
                })
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                this.setState({
                    businessProductType: null,
                    businessProductTypeLoader: false
                })
            })


    }

    onChangeProgramType = (val) => {
        const loadingMessage = message.loading("Updating...", 0);
        this.setState({
            programTypeLoader: true
        })
        CaseService.updateCaseDetailV2(this.props.caseId, { 'program_type': val })
            .then((resp) => {
                loadingMessage();
                this.setState({
                    programTypeLoader: false,
                })
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                loadingMessage();
                message.error("Failed to update Program type. Please try again.");
                this.setState({
                    programTypeLoader: false,
                })
            })

    }

    onChangeOfficeCpv = (_) => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailCPV(this.props.caseId, {
            associate: null,
            status: _,
            cpv_type: 2
        })
            .then((resp) => {
                loadingMessage();
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                console.log("inside catch office cpv", err);
                loadingMessage();
            })
    }

    onChangeDeviationTag = (_) => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailV2(this.props.caseId, {
            is_deviation_tagged: _
        })
            .then((resp) => {
                loadingMessage();
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                loadingMessage();
            })
    }

    onChangeftr = (_) => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailFTR(this.props.caseId, {
            ftr_category: _,
        })
            .then((resp) => {
                loadingMessage();
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                console.log("inside catch FTR", err);
                loadingMessage();
            })
    }

    onChangeResidenceCpv = (_) => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailCPV(this.props.caseId,
            {
                associate: _.applicant,
                status: _.status,
                cpv_type: 1
            })
            .then((resp) => {
                loadingMessage();
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                console.log("inside catch cpv", err);
                loadingMessage();
            })
    }

    onCaseCategoryTagChange = (value) => {
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseCategoryTag(this.props.caseId,
            {
                case_category: value
            })
            .then((resp) => {
                return CaseService.getCaseCategoryTag(this.props.caseId);
            })
            .then((resp) => {
                loadingMessage();
                console.log("Fetched updated tag:", resp.data)
            })
            .catch((err) => {
                console.log("inside catch case category tag", err);
                loadingMessage();
            })
    }

    generateCpvMenu = () => {
        const STATUS_COLORS = {
            Initiated: "blue",
            Positive: "green",
            Negative: "red",
            "Non serviceable": "orange",
            Referred: "purple",
        };
        return (
            <Menu>
                {this.props.data.get('residence_cpv')?.map((associate) => {
                    const applicant_status = CPV_STATUS.findEntry(_ => _ == associate.status)
                    return (
                        <Menu.SubMenu key={associate.associate_id} disabled={[14, 24, 35, 13, 17].includes(this.props.stageId)} title={
                            <>
                                {associate.associate_name}{" "}
                                {applicant_status && (
                                    <span
                                        style={{
                                            color: STATUS_COLORS[applicant_status[0]] || "black",
                                        }}
                                    >
                                        ({applicant_status[0]})
                                    </span>
                                )}
                            </>
                        }>
                            {CPV_STATUS.map((_, key) => (
                                <Menu.Item value={_} key={_} onClick={() =>
                                    this.onChangeResidenceCpv({
                                        applicant: associate.associate_id,
                                        status: _,
                                    })
                                }>{key}</Menu.Item>
                            )).toList()}
                        </Menu.SubMenu>
                    )
                })}
            </Menu>
        )
    }
    get_anchors_user_view = () => {
        const { anchors_list, data } = this.props;
        let anchors = (this.props.supply_chain_anchor && this.props.supply_chain_anchor.length) ? this.props.supply_chain_anchor : this.props.data.get('anchors')
        const tooltipContent = anchors.map(_ => _.name + (_.is_anchor_aligned ? "(Aligned)" : "(Not Aligned)") + _.id).join(', ');
        return tooltipContent;

    }

    get_sellers_user_view = () => {
        const { sellers_list, data } = this.props;
        let sellers = (this.props.supply_chain_seller && this.props.supply_chain_seller.length) ? this.props.supply_chain_seller : this.props.data.get('sellers')
        const sellerTooltipContent = sellers.map(_ => _.name + (_.is_anchor_aligned ? "(Aligned)" : "(Not Aligned)") + _.id).join(', ');
        return sellerTooltipContent;
    }
    caseProfile = () => {
        const { anchors_list, sellers_list, data, proposed_limit, bank } = this.props;
        let anchor_tooltip = this.get_anchors_user_view();
        let seller_tooltip = this.get_sellers_user_view();
        var addresses = this.props.company && this.props.company.get('addresses').toList().filter(_ => _.address_type == 1);
        return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#eef5ff" }}>
            <Col lg={2} sm={8}>
                <span className="text-black fw-600">Case Profile</span>
            </Col>
            <Col span={22}>
                <Card bodyStyle={{ padding: "5px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                    <Descriptions className="descriptionLabelStyle" size="small" layout="vertical" column={{ xs: 2, sm: 2, md: 3, lg: 10 }}>
                        <Descriptions.Item label="Industry">{data.get('industry')}</Descriptions.Item>
                        <Descriptions.Item label="Anchor">
                            <React.Fragment>
                                {/* {anchors_list && anchors_list.length && anchors_list.map(_ => */}
                                {/* // eslint-disable-next-line react/jsx-key */}
                                <Tooltip title={this.getValueAnchor(anchor_tooltip)}>
                                    <div key={_} className="description-value-wrap">
                                        {this.getValueAnchor(anchor_tooltip)}
                                    </div>
                                </Tooltip>
                                {/* )} */}
                            </React.Fragment>
                        </Descriptions.Item>
                        {["CIFCL", "MF"].includes(data.bank?.code)
                            ? <Description label={"Product"}>{"Vendor"}</Description>
                            : <Descriptions.Item label="Seller">
                                <React.Fragment>
                                    {/* {sellers_list && sellers_list.length && sellers_list.map(_ => */}
                                    {/* // eslint-disable-next-line react/jsx-key */}
                                    <Tooltip title={this.getValueSeller(seller_tooltip)}>
                                        <div key={_} className="description-value-wrap">
                                            {this.getValueSeller(seller_tooltip)}
                                        </div>
                                    </Tooltip>
                                    {/* )} */}
                                </React.Fragment>

                            </Descriptions.Item>}
                        <Descriptions.Item label="State">{addresses && addresses.size ? addresses.first().getIn(['state', 'name'], '--') : "--"}</Descriptions.Item>
                        <Descriptions.Item label="City">{addresses && addresses.size ? addresses.first().getIn(['city', 'name'], '') : '--'}</Descriptions.Item>
                        <Descriptions.Item label="Case Proposed Limit">{formatCurrency(proposed_limit, true)}
                            <br /> {data?.is_insurance_amortisation_applicable &&
                                (
                                    <b> + {data?.insurance_amortisation_amount || "--"} (Insurance)</b>
                                )}
                        </Descriptions.Item>
                        {/* {this.props.caseId != '130090' && <Descriptions.Item label="Seller Risk %">
                            {this.props.risk_sharing_percentage.map((_, i, arr) => (
                                <span key={i}>
                                    <Tooltip title={this.getValueSeller(seller_tooltip)}>
                                        {_.recourse_structure && _.status != "Signed" ? `${getKeyByValue(RECOURSE_STRUCTURE, _.recourse_structure)}  ${_.security_perc || 0}%` : !_.risk_sharing_perc ? _.status : `${_.risk_sharing_perc}%`} ({_.seller})
                                        {i < arr.length - 1 && ','}
                                        <br />
                                    </Tooltip>
                                </span>
                            ))}
                        </Descriptions.Item>} */}
                        <Descriptions.Item label="Case Type" >{data.case_type === CASE_CATEGORY_TYPES.get("Renewal") ? "Existing (Renewal)" : data?.case_type_sanctioned || "--"}</Descriptions.Item>
                        <Descriptions.Item label="Bank"><span title={bank || "--"}>{data?.bank?.code || "--"}</span></Descriptions.Item>
                        <Descriptions.Item label="Constitution">{this.props.company && CONSTITUTION_TYPES.findKey(_ => _ === this.props.company.constitution)}</Descriptions.Item>
                    </Descriptions>
                </Card>
            </Col>

        </Card>
    }

    portfolioView = () => {
        return <Card className="case_detail_card card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "rgb(236 228 210)" }}>
            <Col lg={2} sm={8}>
                <p className="text-black fw-600">Portfolio View</p>
            </Col>
            <div className="d-flex w-100">
                <Col lg={24} xs={24} sm={24} >
                    <Card bodyStyle={{ padding: "10px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                        <Table
                            size={"middle"}
                            locale={{ emptyText: 'Portfolio Data Not Available' }}
                            columns={PORTFOLIO_COLUMNS}
                            className={"ant-col padless-card w-100"}
                            dataSource={this.props.portfolioViewData}
                            loading={this.props.portfolioViewStatus == STATE_STATUS.FETCHING}
                            noRowSelection={false}
                            pagination={false}

                        />
                    </Card>
                </Col>
            </div>
        </Card>
    }

    productDetailsInfoCard = () => {
        const { tenor, scheme_roi, stop_billing_days } = this.props;
        let product_type_dropdown = [
            { id: 1, value: "Invoice Finance" },
            { id: 2, value: "Vendor Finance" },
            { id: 3, value: "Working Capital Demand Loan" },
            { id: 5, value: "Purchase Invoice Finance" },
            { id: 6, value: "Sales Invoice Finance" },
            { id: 8, value: "Personal Term Loan" },
            { id: 9, value: "Short Term Loan (STL)" },
            { id: 10, value: "CEP" },
        ]
        return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#f0fcf3" }}>
            <Col lg={2} sm={8}>
                <span className="text-black fw-600">Product Details</span>
            </Col>
            <Col span={22}>
                <Card bodyStyle={{ padding: "5px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                    <Descriptions size="small" layout="vertical" column={{ xs: 1, sm: 2, md: 3, lg: 6 }} className="descriptionLabelStyle">
                        <Descriptions.Item label="ROI">{scheme_roi}</Descriptions.Item>
                        <Descriptions.Item label="Tenure">
                            {tenor && `${tenor}`}
                        </Descriptions.Item>
                        {this.props.data.product_scheme_type !== "Term Loan" && <Descriptions.Item label="Stop Billing Days">{stop_billing_days}</Descriptions.Item>}
                        <Descriptions.Item label="Scheme Type">{(this.props.data.product_scheme_type && this.props.data.product_scheme_type) == "Factoring" ? "CEP" : this.props.data.product_scheme_type || "--"}</Descriptions.Item>
                        <Descriptions.Item label="Product Type">
                            <Select
                                disabled={true}
                                // disabled={this.props.userGroups && !this.props.userGroups.some(value => [7, 8].includes(value)) || ![4, 5, 18, 20, 7, 8].includes(this.props.stageId)}
                                placeholder="Select Business Product Type"
                                value={
                                    this.state.businessProductType || this.props.data.get('business_product_type')
                                }
                                style={{ width: 180 }}
                                onChange={this.onChangeBusinessProductType}
                            >
                                {product_type_dropdown.map((_, key) => (
                                    <Option value={_.id} key={key}>{_.value}</Option>
                                ))}
                            </Select>
                        </Descriptions.Item>
                        <Descriptions.Item label="Program Type">
                            <Select
                                disabled={true}
                                // disabled={this.props.userGroups && !this.props.userGroups.some(value => [7, 8].includes(value)) || ![4, 5, 18, 20, 7, 8].includes(this.props.stageId)}
                                placeholder="Select Program Type"
                                value={
                                    this.props.data.get('program_type')
                                }
                                style={{ width: 180 }}
                                onChange={this.onChangeProgramType}
                            >
                                {PROGRAM_TYPE_NEW.map((_, key) => (
                                    <Option value={_} key={_}>{key}</Option>
                                )).toList()}
                            </Select>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            </Col>
        </Card>
    }

    contactPointInfoCard = () => {
        const editPermissionIds = [4, 5, 7, 18, 20];
        const hasEditPermission = editPermissionIds.some(id => this.props.userGroups.includes(id));
        return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#fdf5cf" }}>
            <Col lg={2} sm={8}>
                <span className="text-black fw-600">Contact Points</span>
            </Col>
            <Row gutter={10}>
                <Col span={12}>
                    <Card bodyStyle={{ padding: "5px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                        <Descriptions size="small" layout="vertical" column={2} className="descriptionLabelStyle">
                            <Descriptions.Item label="ASM">
                                {this.props.asm_data && <div>
                                    {this.props.asm_data.full_name}
                                    {this.props.permissions.toJS().hasOwnProperty("can_case_asm_edit") && !this.props.recreditViewOnlyPermission ? <Icon type="edit" onClick={() => this.openAsmEdit()} style={{ fontSize: 15, marginLeft: "10px" }} /> : null}
                                    ({this.props.data.get('current_asm_details')?.distance_km ?? 'NA'})
                                </div>}
                            </Descriptions.Item>
                            <Descriptions.Item label="DRM">
                                {this.props.data.toJS().distributor_relationship_manager || "--"}
                                ({this.props.data.get('current_rm_details')?.distance_km ?? 'NA'})
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card bodyStyle={{ padding: "5px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                        <Descriptions size="small" layout="vertical" column={2} className="descriptionLabelStyle">
                            <Descriptions.Item label="Reporting Industry">
                                {typeof this.state.selectedIndustryVal == "string" ? this.state.selectedIndustryVal : this.props.data.getIn(['reporting_industry', 'name']) || "--"}
                                {hasEditPermission && <Icon type="edit" onClick={() => this.openIndustryEdit()} style={{ fontSize: 15, marginLeft: "10px" }} />}
                            </Descriptions.Item>
                            <Descriptions.Item label="Reporting Anchor">
                                {typeof (this.state.selectedAnchorVal) == "string" ? this.state.selectedAnchorVal : (this.props.data.getIn(['reporting_anchor', 'name']) && this.props.data.getIn(['reporting_anchor', 'name'])) == 'Factoring' ? "CEP" : this.props.data.getIn(['reporting_anchor', 'name']) || "--"}
                                {hasEditPermission && <Icon type="edit" onClick={() => this.openAnchorEdit()} style={{ fontSize: 15, marginLeft: "10px" }} />}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>
            </Row>
        </Card>
    }


    miscellaneousInfoCard = () => {
        const { data } = this.props;
        return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#edf1ff" }}>
            <Col lg={2} sm={8}>
                <span className="text-black fw-600">Miscellaneous</span>
            </Col>
            <Col span={22}>
                <Card bodyStyle={{ padding: "5px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                    <Descriptions size="small" layout="vertical" column={{ xs: 1, sm: 2, md: 3, lg: 7 }} className="descriptionLabelStyle">
                        <Descriptions.Item label="Is Insurance Mandatory">
                            <Select style={{ width: 150 }}
                                placeholder={"Select Insurance Mandatory"}
                                disabled={![7].includes(this.props.stageId)}
                                onChange={(item) => this.onInsuranceChange(item)}
                                value={this.state.insuranceAttached}
                            >
                                <Option key={1} value={true}>{"Yes"}</Option>
                                <Option key={2} value={false}>{"No"}</Option>
                            </Select>
                        </Descriptions.Item>
                        <Descriptions.Item label="Is Insurance Attached">
                            {this.props.data.get('is_insurance_attached') ? "Yes" : "No" || null}
                        </Descriptions.Item>
                        {this.props.data.toJS().kyc_status == "Not Required" ? <Description label="KYC CDD">
                            <label>Not Required</label>
                        </Description> :
                            <Descriptions.Item label="KYC CDD">
                                <Select style={{ width: 150 }}
                                    placeholder={"Select KYC type"}
                                    disabled={[11, 14, 24, 35, 13, 17, 57, 10].includes(this.props.stageId)}
                                    onChange={(item) => this.onKycChange(item)}
                                    value={this.state.kycValue || this.props.data.toJS().kyc_status && KYC_ENUM.findEntry(_ => _ == this.props.data.toJS().kyc_status)[0] || "--"}
                                >
                                    <Option key={1} value={1}>{"OSV"}</Option>
                                    <Option key={2} value={2}>{"VKYC"}</Option>
                                </Select>
                            </Descriptions.Item>}
                        {this.props.caseId != 130090 && <Descriptions.Item label="DB Tag">
                            {this.props.data.sellers[0]?.db_tagging && DB_TAGGING.findEntry(_ => _ == this.props.data.sellers[0]?.db_tagging)[0] || "--"}
                        </Descriptions.Item>}
                        {this.props.caseId != 130090 && this.props.data.mou_50_50_risk_sharing && this.props.data.mou_50_50_risk_sharing.length ? <Descriptions.Item label="Seller MOU Risk">
                            <Tooltip title={this.props.data.mou_50_50_risk_sharing.map(el => <p>{el.seller_name} : {el.status}</p>)}>
                                {this.props.data.mou_50_50_risk_sharing.map(el => <div>
                                    {el.status}<div style={{ display: "flex" }}><label className="overflow-hidden">({el.seller_name}</label>)</div>
                                </div>)}
                            </Tooltip>
                        </Descriptions.Item> : <></>}
                        {this.props.stageId === 20 && <Descriptions.Item label="FTR Category">
                            <Select
                                placeholder="Select FTR Category"
                                value={
                                    FTR_CATEGORY.findEntry(_ => _ == this.props.data.get('ftr_category')) ?
                                        FTR_CATEGORY.findEntry(_ => _ == this.props.data.get('ftr_category'))[0] : undefined
                                }
                                style={{ width: 150 }}
                                onChange={this.onChangeftr}
                            >
                                {FTR_CATEGORY.map((_, key) => (
                                    <Option value={_} key={_}>{key}</Option>
                                )).toList()}
                            </Select>
                        </Descriptions.Item>}
                        <Descriptions.Item label="Office CPV">
                            <Select style={{ width: 150 }}
                                placeholder="Select Office CPV"
                                disabled={[14, 24, 35, 13, 17].includes(this.props.stageId)}
                                value={
                                    CPV_STATUS.findEntry(_ => _ == this.props.data.get('office_cpv_status')) ?
                                        CPV_STATUS.findEntry(_ => _ == this.props.data.get('office_cpv_status'))[0] : undefined
                                }
                                onChange={this.onChangeOfficeCpv}
                            >
                                {CPV_STATUS.map((_, key) => (
                                    <Option value={_} key={_}>{key}</Option>
                                )).toList()}
                            </Select>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            </Col>
        </Card>
    }

    handleSubmitNote = () => {
        const { growthPlanText } = this.state;
        if (!growthPlanText.trim()) {
            message.warning("Please enter a note before submitting");
            return;
        }
        this.setState({ submitting: true });
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateCaseDetailV2(this.props.caseId, {
            growth_plan_parameter: growthPlanText
        }).then((resp) => {
            loadingMessage();
            this.setState({ submitting: false });
            message.success("Note submitted successfully");
            this.props.fetchCaseDetail(this.props.caseId);
        })
            .catch((err) => {
                loadingMessage();
                this.setState({ submitting: false });
                message.error("Failed to submit note");
            })
    };

    generateGrowthPlanSentence = ({ aum, noOfRTs, timeline }) => {
        if (!aum && !noOfRTs && !timeline) return "";

        const formatted = timeline ? moment(timeline).format("DD MMM YYYY") : "";

        return `Planned AUM of ₹${aum}, with ${noOfRTs} RTs, targeted by ${formatted}.`;
    };

    onGrowthPlanSubmit = () => {
        const { growthPlan } = this.state;
        const formattedTimeline = growthPlan.timeline
            ? growthPlan.timeline.format("YYYY-MM-DD")
            : null;

        const loadingMessage = message.loading("Updating...", 0);

        const growthPlanSentence = this.generateGrowthPlanSentence({
            ...growthPlan,
            timeline: formattedTimeline
        });

        const existingJson = this.props.data?.json_data || {};
        const updatedJsonData = {
            ...existingJson,
            growth_plan_details: {
                aum: growthPlan.aum,
                noOfRTs: growthPlan.noOfRTs,
                timeline: formattedTimeline
            }
        };
        const payload = {
            growth_plan_parameter: growthPlanSentence,
            json_data: updatedJsonData
        };

        this.setState({ isGrowthPlanModalVisible: false });
        CaseService.updateCaseDetailV2(this.props.caseId, payload).then((resp) => {
            loadingMessage();
            message.success("Growth plan submitted successfully");
            this.props.fetchCaseDetail(this.props.caseId);
        })
            .catch((err) => {
                loadingMessage();
                message.error("Failed to submit");
            })
    };

    onTNCCreditSubmit = () => {
        const { tncCredit } = this.state;

        if (!tncCredit) {
            message.error("No data to update");
            return;
        }
        const loadingMessage = message.loading("Updating...", 0);
        const existingJsonData = this.props?.data?.json_data || {};
        const payload = {
            json_data: {
                ...existingJsonData,
                tncCredit: {
                    deviationTag: tncCredit.deviationTag || null,
                    creditRemark: tncCredit.creditRemark || "",
                    postSanctionRemark: tncCredit.postSanctionRemark || "",
                },
            },
        };
        this.setState({ isTNCCreditModalVisible: false });
        CaseService.updateCaseDetailV2(this.props.caseId, payload)
            .then(() => {
                loadingMessage();
                message.success("T&C Credit updated successfully");
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch(() => {
                loadingMessage();
                message.error("Failed to submit T&C Credit");
            });
    };

    openGrowthPlanModal = () => {
        const gp = this.props?.data?.json_data?.growth_plan_details || {};

        this.setState({
            isGrowthPlanModalVisible: true,
            growthPlan: {
                aum: gp.aum || "",
                noOfRTs: gp.noOfRTs || "",
                timeline: gp.timeline && moment(gp.timeline).isValid()
                    ? moment(gp.timeline)
                    : null,
            }
        });
    };

    openTNCCreditModal = () => {
        const tncCreditFromApi = this.props.data?.json_data?.tncCredit || {};

        this.setState({
            isTNCCreditModalVisible: true,
            tncCredit: {
                deviationTag: tncCreditFromApi?.deviationTag || null,
                creditRemark: tncCreditFromApi?.creditRemark || "",
                postSanctionRemark: tncCreditFromApi?.postSanctionRemark || "",
            },
        });
    };

    handleGrowthPlanChange = (key, value) => {
        this.setState({
            growthPlan: {
                ...this.state.growthPlan,
                [key]: value
            }
        });
    };


    growthPlanCard = () => {
        const { data } = this.props;
        return <div className="d-flex" >

            <Input.TextArea
                rows={3}
                placeholder="Enter your text here..."
                disabled
                value={this.state?.growthPlanText || ""}
                onChange={(e) => this.setState({ growthPlanText: e.target.value })}
            // disabled={!([7, 8].includes(this.props.stageId))}
            />
            {/* <Button
                type="primary"
                className="w-40 mt-10 ml-10"
                onClick={this.handleSubmitNote}
                loading={this.state.submitting}
                disabled={!([7, 8].includes(this.props.stageId))}
            >
                Submit
            </Button> */}
        </div>
    }

    termsConditionCard = (value) => {
        return <div className="d-flex" >
            <Input.TextArea
                rows={2}
                placeholder="Enter your text here..."
                disabled
                value={value || ""}
            />
        </div>
    }

    onHighValueCaseChange = (val) => {
        const loadingMessage = message.loading("Updating...", 0);
        this.setState({
            caseDetailUpdateLoader: true,
        });
        CaseService.updateCaseDetailV2(this.props.caseId, { 'is_high_value_case': val })
            .then((resp) => {
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                message.error("Failed to update. Please try again.");
            })
            .finally(() => {
                loadingMessage();
                this.setState({ caseDetailUpdateLoader: false });
            });

    }



    actionableInfoCard = () => {
        const { data } = this.props;
        return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#edf1ff" }}>
            <Col lg={2} sm={8}>
                <span className="text-black fw-600">Actionable</span>
            </Col>
            <Col span={22}>
                <Card bodyStyle={{ padding: "5px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                    <Descriptions size="small" layout="vertical" column={{ xs: 1, sm: 2, md: 3, lg: 6 }} className="descriptionLabelStyle">
                        <Descriptions.Item label="Case Category">
                            <Select
                                placeholder="Select Case Category"
                                disabled={!this.props.userGroups?.includes(7) || (![7].includes(this.props.stageId))}
                                value={
                                    this.state.caseCategory ?? 0
                                }
                                onChange={(value) => {


                                    this.setState({
                                        caseCategory: Number(value)
                                    });
                                    this.onCaseCategoryTagChange(value);

                                }}
                                style={{ width: 150 }}
                            >
                                {CASE_CATEGORY.entrySeq().map(([label, value]) => (
                                    <Option value={value} key={value}>{label}</Option>
                                )).toArray()}
                            </Select>
                        </Descriptions.Item>
                        <Descriptions.Item size="small" layout="vertical" column={{ xs: 1, sm: 2, md: 3, lg: 6 }} label="Residence CPV">
                            <Dropdown overlay={this.generateCpvMenu()}>
                                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                    Select Residence CPV <Icon type="down" />
                                </a>
                            </Dropdown>
                        </Descriptions.Item>
                        <Descriptions.Item label="Deviation Tag">
                            {<Select style={{ width: 150 }}
                                placeholder={"Select Deviation Tag"}
                                disabled={![7, 8].includes(this.props.stageId)}
                                onChange={(item) => this.onChangeDeviationTag(item)}
                                value={this.props.data.get('is_deviation_tagged') && BOOLEAN_OPTIONS.findEntry(_ => _ == this.props.data.get('is_deviation_tagged'))[0] || false}
                            >
                                {BOOLEAN_OPTIONS.map((_, key) => (
                                    <Option value={_} key={_}>{key}</Option>
                                )).toList()}
                            </Select>}
                        </Descriptions.Item>
                        <Descriptions.Item label="Terms & Condition">
                            <Button type="primary" onClick={this.openTNCCreditModal}>
                                Terms & Condition
                            </Button>
                        </Descriptions.Item>
                        <Descriptions.Item label="Credit T&C">
                            {this.termsConditionCard(this.props.data?.json_data?.tncCredit?.creditRemark || "")}
                        </Descriptions.Item>
                        <Descriptions.Item label="Post Sanction Remark on T&C">
                            {this.termsConditionCard(this.props.data?.json_data?.tncCredit?.postSanctionRemark || "")}
                        </Descriptions.Item>
                        <Descriptions.Item label="Add Growth Plan">
                            <Button type="primary" onClick={this.openGrowthPlanModal}>
                                Add Growth Plan
                            </Button>
                        </Descriptions.Item>
                        <Descriptions.Item className="ml-5" label="PD Declaration">
                            <Button type="primary" onClick={() => {
                               this.showHidePDDeclarationForm()
                            }}>PD Declaration</Button>
                        </Descriptions.Item>
                        <Descriptions.Item label="Is High Value Case"> 
                            <Switch loading={this.state.caseDetailUpdateLoader} disabled={this.state.caseDetailUpdateLoader} onChange={(val) => this.onHighValueCaseChange(val)} checked={this.props.is_high_value_case}/>
                        </Descriptions.Item>
                        <Descriptions.Item label="Growth Plan">
                            {this.growthPlanCard()}
                        </Descriptions.Item>
                     
                    </Descriptions>
                </Card>
            </Col>
        </Card>
    }

    

    caseTagsCard = () => {
        const { data } = this.props;
        const SELLER_HOLD_REASON_LABELS = Object.fromEntries(
            Array.from(SELLER_HOLD_REASONS, ([label, id]) => [id, label])
        );

        const seller_status = data.supply_chains.filter(el => el?.seller?.hold_reason_lms && el.seller.hold_reason_lms !== 0).map(el => ({
            [el.seller.name]: SELLER_HOLD_REASON_LABELS[el.seller.hold_reason_lms] || "--"
        }))
        if (data && data.industry_level_max_capping == true || this.props.parent_fi_movement_cases.length > 0 || this.props.child_fi_movement_cases.length > 0 || this.props.data.co_lending_limit_split && Object.keys(this.props.data.co_lending_limit_split).length || this.props.data.enhancement_green_channel
            || this.props.data.pre_approval_leads || this.props.data.is_related_to_distributor || this.props.data.at_high_risk || data.is_bundled) {
            return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#fef2f2" }}>
                <Col lg={2} sm={8}>
                    <span className="text-black fw-600">Tags</span>
                </Col>
                <Col span={22}>
                    <Card bodyStyle={{ padding: "10px 5px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                        <div className="d-flex flex-column" style={{ margin: "0 1rem" }}>
                            <div className="d-flex flex-row justify-content-space-between align-items-center">
                                {data && data.industry_level_max_capping == true &&
                                    <span className="credit-limit-fields">
                                        Industry level limit breach
                                    </span>}
                                {this.props.parent_fi_movement_cases.length > 0 ?
                                    <Tag color="green">
                                        <span>FI Movement Case For: </span>{this.props.parent_fi_movement_cases.map(el => (` ${el.id}(${el.partner_bank.code})`)) + "" || "--"}
                                    </Tag> : <></>
                                }
                                {this.props.child_fi_movement_cases.length > 0 ?
                                    <Tag color="green">
                                        <span>Case moved to FI:</span> {this.props.child_fi_movement_cases.map(el => (`${el.partner_bank.code}(${el.id})`)) + "" || "--"}
                                    </Tag>
                                    : <></>}
                                {this.props.data.co_lending_limit_split && Object.keys(this.props.data.co_lending_limit_split).length ?
                                    <Tag color="green">
                                        {Object.keys(this.props.data.co_lending_limit_split).map(el => (<div>
                                            <span className="ant-descriptions-item-label ant-descriptions-item-colon">{el.replace('HHPL', 'PPL') + " Limit"}</span>
                                            {formatCurrency(this.props.data.co_lending_limit_split[el], true)}
                                        </div>))}
                                    </Tag>
                                    : <></>}
                                {this.props.data.enhancement_green_channel ?
                                    <Tag color="green">
                                        <span>Enhancement Green Channel </span>
                                    </Tag> : <></>
                                }
                                {this.props.data.pre_approval_leads ?
                                    <Tag color="#9f9b0c">
                                        <span>Pre-Approved Lead</span>
                                    </Tag> : <></>
                                }
                                {this.props.data.is_related_to_distributor !== null &&
                                    <Tag color="#85b1df">
                                        <span>
                                            DB Relationship: {this.props.data.is_related_to_distributor ? "YES" : "NO"}
                                        </span>
                                    </Tag>}
                                {this.props.data.at_high_risk &&
                                    <Tag color="#ec0519">
                                        <span>
                                            High Risk Customer
                                        </span>
                                    </Tag>}
                                {this.props.data.is_bundled &&
                                    <Tag color="#ec9705">
                                        <span>
                                            Bundled
                                        </span>
                                    </Tag>}
                                <div className="d-flex flex-column">
                                    {seller_status && seller_status.map((item, index) => {
                                        const sellerName = Object.keys(item)[0];
                                        const holdStatus = item[sellerName];

                                        return (
                                            <Tag key={index} color="#6f7269" className="mb-5">
                                                <span>
                                                    {sellerName} — <strong>{holdStatus}</strong>
                                                </span>
                                            </Tag>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Card>
        }
        return <></>

    }

    authorityApproval = () => {
        const { data } = this.props;
        if (this.props.stageId == AUTHORITY_APPROVAL_STAGE_ID && this.props.permissions.toJS().hasOwnProperty("appropriate_approval_edit") && this.state.approverDetails.length) {
            return <Card className="card-align-center" bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, background: "#fef2f2" }}>
                <Col lg={2} sm={8}>
                    <span className="text-black fw-600">Appropriate Approval</span>
                </Col>
                <Row gutter={10} style={{ width: "100%" }}>
                    <Col span={12}>
                        <Card bodyStyle={{ padding: 0 }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                            <div className="d-flex flex-column" style={{ margin: "0 1rem" }}>
                                <div className="d-flex flex-row justify-content-space-between">
                                    {this.state.approverDetails.length ? this.authorityApprovalTable(this.state.approverDetails[0]) : <></>}
                                </div>
                            </div>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card bodyStyle={{ padding: 0 }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                            <div className="d-flex flex-column" style={{ margin: "0 1rem" }}>
                                <div className="d-flex flex-row justify-content-space-between">
                                    {this.state.approverDetails.length ? this.authorityApprovalTable(this.state.approverDetails[1]) : <></>}
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Card>
        }
        return <></>
    }

    authorityApprovalTable = (_) => {
        return <table className="custom-table_static_v2">
            <thead>
                <tr>
                    <th></th>
                    <th>Is Required</th>
                    <th>Is Approved</th>
                    <th>Reference</th>
                </tr>
            </thead>
            <tbody>
                <tr className="mt-10">
                    <td>{_.name}</td>
                    <td>{_.is_required ? "Yes" : "No"}</td>
                    <td>{_.is_approved != null ? _.is_approved : <Select className="select-squeeze" onChange={(val) => {

                        this.setState(prevState => ({
                            isApproved: {
                                ...prevState.isApproved,
                                [_.name]: val
                            }
                        }))
                    }} style={{ width: 70 }}>
                        <Option value="Approved">Yes</Option>
                        <Option value="Rejected">No</Option>
                    </Select>}</td>
                    <td>{_.is_approved == null ? <Upload
                        action={null}
                        disabled={this.state.loading}
                        onChange={({ file }) => {
                            if (file.status === "uploading" && !this.state.loading) {
                                this.setState({
                                    loading: true
                                })
                                message.loading("File Uploading")
                            }
                            if (file.status === "done") {
                                message.success("Successfully Approved")
                                this.fetchApprovalDetails();
                                this.setState({
                                    loading: false
                                })

                            }
                            if (file.status === "error") {
                                this.setState({
                                    loading: false
                                })
                                message.destroy();
                                message.error("Failed to Upload file");
                            }

                        }
                        }
                        {...{
                            directory: false, // Upload Directory Support
                            multiple: false, // Upload Multiple files support,
                            action:
                                `${process.env.BASE_URL}/case/${this.props.caseId}/approval/by-approver/`,
                            showUploadList: false,
                            headers: {
                                Authorization: `Bearer ${getAuthToken().authToken}`
                            },
                            data: file => ({
                                document: file,
                                status: this.state.isApproved[_.name],
                                approver_for_email: _.email,
                            }),
                        }}
                    >
                        <Button className="button-squeeze">
                            <Icon type="upload" /> Upload
                        </Button>
                    </Upload> : <Tag color="green">Uploaded</Tag>}</td>
                </tr>
            </tbody>
        </table>
    }

    showHidePDDeclarationForm = () => {
        this.setState({
            showPDDeclarationform : !this.state.showPDDeclarationform
        })
    }

    render() {
        let product_type_dropdown = [
            { id: 1, value: "Invoice Finance" },
            { id: 2, value: "Vendor Finance" },
            { id: 3, value: "Working Capital Demand Loan" },
            { id: 5, value: "Purchase Invoice Finance" },
            { id: 6, value: "Sales Invoice Finance" },
            { id: 8, value: "Personal Term Loan" },
            { id: 9, value: "Short Term Loan (STL)" },
        ]
        if (this.props.data.scheme_type == "Vendor Finance") {
            product_type_dropdown = product_type_dropdown.filter((_) => [2].includes(_.id))
        } else if (this.props.data.scheme_type == "Term Loan") {
            product_type_dropdown = product_type_dropdown.filter((_) => [3, 8, 9].includes(_.id))
        } else if (["Default Scheme", "Combinational Scheme", "Rff Level Scheme", "Per Unit Subvention Scheme", "Subvention Basis Invoice Date"].includes(this.props.data.scheme_type)) {
            product_type_dropdown = product_type_dropdown.filter((_) => [1, 5, 6].includes(_.id))
        } else {
            product_type_dropdown = []
        }
        const { proposed_limit, tenor, anchors_list, sellers_list, bank, existing_limit } = this.props;
        const tooltipContent = anchors_list.map(_ => {
            const filteredAnchors = this.props.data.get('anchors').filter(anchor => Number(anchor.id) === Number(_.split("|")[1]));
            const result = filteredAnchors.map(anchor => _.split("|")[0] + (anchor.is_anchor_aligned ? "(Aligned)" : "(Not Aligned)")).join(', ');
            return result;
        });
        const tooltipTitle = tooltipContent.join(', ');
        let anchors = (
            <React.Fragment>
                {anchors_list && anchors_list.length && anchors_list.map(_ =>
                    // eslint-disable-next-line react/jsx-key
                    <div key={_}>
                        {this.getValue(_)}
                    </div>
                )}
            </React.Fragment>
        );

        let sellers = (
            <React.Fragment>
                {sellers_list && sellers_list.length && sellers_list.map(_ =>
                    // eslint-disable-next-line react/jsx-key
                    <div key={_}>
                        {this.getValue(_)}
                    </div>
                )}
            </React.Fragment>
        );

        // const previousSanctionLimit = casesList && casesList.size && (casesList.sort((a, b) => {
        //     if(a.create_date > b.create_date) {
        //         return -1;
        //     } else if(a.create_date < b.create_date) {
        //         return 1;
        //     } else if(a.create_date === b.create_date) {
        //         return 0;
        //     }
        // }).filter(_ => _.sanction_date).first() || {}).sanction_limit;
        const { data } = this.props;
        const holdbackText = " Holdback<10%";
        const DBOverdue = " DB Overdue>50%";
        // const dbPortfolioPerc = this.props.dbViewTableData && this.props.dbViewTableData.perc_db_portfolio_overdue && this.props.dbViewTableData.perc_db_portfolio_overdue.values.find(el=>el.value > 50);
        let supplyChainAnchorZetwerk = this.props.data?.supply_chains.find(el => el.anchor.name === "Zetwerk Manufacturing Businesses Private Limited" || el.anchor.name === "Hella Infra Market Private Limited");
        const editPermissionIds = [4, 5, 7, 18, 20];
        const hasEditPermission = editPermissionIds.some(id => this.props.userGroups.includes(id));
        return (
            <React.Fragment>
                {this.state.showPDDeclarationform && <PDDeclarationForm stageId={this.props.stageId} caseJsonDataFetch={this.caseJsonDataFetch} values={this.state.caseJsonData?.pd_declaration} caseId={this.props.caseId}  showHidePDDeclarationForm={this.showHidePDDeclarationForm}/>}
                <DocumentUploadModal
                    loading={this.state.uploadKYCDocumentLoader}
                    title={this.state.enum_value == 1 ? "OSV Document" : 'VKYC Document'}
                    showModal={this.state.showDocumentUplaod}
                    uploadDocument={(files) => this.onSubmitKycChange(files)}
                    closeModal={() => this.setState({ showDocumentUplaod: false })}
                    multiple={true}
                    view_documents_list={true}
                    documents_list={this.props.files && this.state.enum_value && this.props.files.filter(file => {
                        const documentName = this.state.enum_value === 1 ? 'OSV' : this.state.enum_value === 2 ? 'VKYC' : '';
                        if (file.document && file.document.document_name) {
                            return file.document.document_name === documentName;

                        }
                        else return false;
                    })}
                />

                {this.caseProfile()}
                <span style={{ display: "block", height: 15 }}></span>
                {![130090, 141834].includes(this.props.caseId) && this.portfolioView()}
                <span style={{ display: "block", height: 15 }}></span>
                {this.productDetailsInfoCard()}
                <span style={{ display: "block", height: 15 }}></span>
                {this.contactPointInfoCard()}
                <span style={{ display: "block", height: 15 }}></span>
                {this.miscellaneousInfoCard()}
                <span style={{ display: "block", height: 15 }}></span>
                {this.actionableInfoCard()}
                <span style={{ display: "block", height: 15 }}></span>
                {this.caseTagsCard()}
                <span style={{ display: "block", height: 15 }}></span>
                {/* {this.authorityApproval()} */}

                {/* <Descriptions column={6} className={"summary"}>
                    {["CIFCL", "MF"].includes(data.bank?.code) && supplyChainAnchorZetwerk !== undefined ? <Description label={"Product"}>{"Vendor"}</Description> : <Description label={"Seller"}>{sellers || ""}</Description>}
                    {data.bank?.code != "FSFB" ? <Description label={"Anchor"} className="descriptionPadding">
                        <Tooltip  title={tooltipTitle} >
                            <div>{anchors || ""}</div>
                        </Tooltip>    
                    </Description> : null}
                    {data.bank?.code == "FSFB" ? <Description label={"Industry"}>{data.toJS().industry || ""}</Description> : null}
                    {["CIFCL", "MF"].includes(data.bank?.code) ? <Description label={"Industry"}>{data.toJS().industry || ""}</Description> : null}
                    <Description label={"Tenor"}>{tenor && `${tenor}`}</Description>
                    <Description label={"Bank"}>{bank || ""}</Description>
                    <Description label={"Case Type"}>{CASE_CATEGORY_TYPES.findKey(_ => _ === this.props.currentCaseType)}</Description>
                    <Description label={"Recommended Limit"}>{formatCurrency(limit_basis_sales_display, true) || ""}</Description>
                    {![1, 6].includes(this.props.currentCaseType) ?
                        <Description label={"Existing Limit"}>
                            {
                                existing_limit ? formatCurrency(existing_limit, true)
                                    : "Unable to get Last Sanction Limit"
                            }
                        </Description> : null
                    }
                    <Description label={"Proposed Limit"}>
                        <div className="d-flex align-items-center">
                        {formatCurrency(proposed_limit, true)}
                        {this.props.data.tradelink_flag_2x && <div style={{fontSize:"20px", border:"1px solid #cac7c7",marginLeft:"8px"}}>
                                <span style={{color:"#246079"}}>2</span> 
                                <span style={{color:"rgb(37, 168, 65)"}}>X</span>
                            </div>}
                        </div>
                    </Description>
                    {
                        this.props.asm_data && <Description label={"ASM"}>
                            {this.props.asm_data.full_name}
                            {this.props.permissions.toJS().hasOwnProperty("can_case_asm_edit") && !this.props.recreditViewOnlyPermission ? <Icon type="edit" onClick={() => this.openAsmEdit()} style={{ fontSize: 15, marginLeft: "10px" }} /> : null}
                        </Description>
                    }
                    {
                        <Description label={"Reporting Industry"}>
                            {typeof this.state.selectedIndustryVal == "string" ? this.state.selectedIndustryVal : this.props.data.getIn(['reporting_industry', 'name']) || "--"}
                            {hasEditPermission && <Icon type="edit" onClick={() => this.openIndustryEdit()} style={{ fontSize: 15, marginLeft: "10px" }} />}
                        </Description>
                    }
                    {
                        <Description label={"Reporting Anchor"}>
                            {typeof(this.state.selectedAnchorVal) == "string" ? this.state.selectedAnchorVal : this.props.data.getIn(['reporting_anchor', 'name']) || "--"}
                            {hasEditPermission && <Icon type="edit" onClick={() => this.openAnchorEdit()} style={{ fontSize: 15, marginLeft: "10px" }} />}
                        </Description>
                    }
                    {
                        this.props.isp_data && <Description label={"ISP"}>
                            {this.props.isp_data.full_name}
                            {this.props.permissions.toJS().hasOwnProperty("can_case_asm_edit") && !this.props.recreditViewOnlyPermission ? <Icon type="edit" onClick={() => this.openIspEdit()} style={{ fontSize: 15, marginLeft: "10px" }} /> : null}
                        </Description>
                    }
                    {
                        this.props.data.toJS().distributor_relationship_manager ? <Description label={"DRM"}>
                            {this.props.data.toJS().distributor_relationship_manager}
                        </Description> : <Description label={"DRM"}>
                            --
                        </Description>
                    }
                    {
                        this.props.data?.product_scheme_type && <Description label={"Scheme Type"}>
                            {this.props.data.product_scheme_type || null}
                        </Description>
                    }
                    {
                        <Description label={"Is Insurance Attached"}>
                            {this.props.data.get('is_insurance_attached') ? "Yes" : "No" || null}
                        </Description>
                    }
                    {
                        <Description label={"Primary Lang."}>
                            {this.props.data.toJS().primary_language && PRIMARY_LANGUAGE.findEntry(_ => _ == this.props.data.toJS().primary_language)[0] || "--"}
                        </Description>
                    }
                    {
                        <Description label={"DB Tag"}>
                            {this.props.data.sellers[0]?.db_tagging && DB_TAGGING.findEntry(_ => _ == this.props.data.sellers[0]?.db_tagging)[0] || "--"}
                        </Description>
                    }
                    {
                        this.props.data.toJS().secondary_language && <Description label={"Secondary Lang."}>
                            {SECONDARY_LANGUAGE.findEntry(_ => _ == this.props.data.toJS().secondary_language)[0] || "--"}
                        </Description>
                    }
                    {this.props.parent_fi_movement_cases.length > 0 &&
                        <Description label={"FI Movement Case For"}>
                            {this.props.parent_fi_movement_cases.map(el => (` ${el.id}(${el.partner_bank.code})`)) + "" || "--"}
                        </Description>
                    }
                    {this.props.child_fi_movement_cases.length > 0 &&
                        <Description label={"Case moved to FI:"}>
                            {this.props.child_fi_movement_cases.map(el => (`${el.partner_bank.code}(${el.id})`)) + "" || "--"}
                        </Description>
                    }
                    {this.props.data.co_lending_limit_split && Object.keys(this.props.data.co_lending_limit_split).length &&
                        <Description label={""}>
                            {Object.keys(this.props.data.co_lending_limit_split).map(el => (<div>
                                <span className="ant-descriptions-item-label ant-descriptions-item-colon">{el.replace('HHPL' , 'PPL') + " Limit"}</span>
                                {formatCurrency(this.props.data.co_lending_limit_split[el], true)}
                            </div>))}
                        </Description>
                    }

                    {
                        this.props.data.mou_50_50_risk_sharing ? this.props.data.mou_50_50_risk_sharing.length &&
                                <Description label={"Seller MoU (50-50 Risk)"} span={1} className="descriptionPadding">
                            <Tooltip  title={this.props.data.mou_50_50_risk_sharing.map(el=> <p>{el.seller_name} : {el.status}</p>)}>

                                {this.props.data.mou_50_50_risk_sharing.map(el => (<div>
                                    {el.status}<div style={{display: "flex"}}><label className="overflow-hidden">({el.seller_name}</label>)</div>
                                </div>))}
                            </Tooltip>

                                </Description>
                             : <></>
                    }
                </Descriptions> */}
                {/* <Row style={{margin:"1rem 0"}}>
                    <Col span="3">
                {["HHPL", "KSF|HHPL", "MF", "MFL", "MFL|HHPL"].includes(data && data.bank?.code) && <div>
                    KYC CDD: <Select style={{ width: 150 }}
                     placeholder={"Select KYC type"} 
                     disabled={[11,14,24,35,13,17,57].includes(this.props.stageId)} 
                     onChange={(item) => this.onKycChange(item)} 
                     value={this.state.kycValue || this.props.data.toJS().kyc_status &&  KYC_ENUM.findEntry(_ => _ == this.props.data.toJS().kyc_status)[0] || "--"}
                     >
                        <Option key={1} value={1}>{"OSV"}</Option>
                        <Option key={2} value={2}>{"VKYC"}</Option>
                    </Select>
                </div>}
                </Col>
                    <Col span="3">
                {<div>
                    Insurance Mandatory: <Select style={{ width: 150 }}
                     placeholder={"Select Insurance Mandatory"} 
                     disabled={![7].includes(this.props.stageId)} 
                     onChange={(item) => this.onInsuranceChange(item)} 
                     value={this.state.insuranceAttached}
                     >
                        <Option key={1} value={true}>{"Yes"}</Option>
                        <Option key={2} value={false}>{"No"}</Option>
                    </Select>
                </div>}
                </Col>
                    <Col span="4">
                        <Spin style={{ margin: "1rem 0" }} spinning={this.state.businessProductTypeLoader}>
                                Business Product Type<Select
                                    disabled={this.props.userGroups && !this.props.userGroups.some(value => [7, 8].includes(value)) || ![4, 5, 18, 20, 7, 8].includes(this.props.stageId)}
                                    placeholder="Select Business Product Type"
                                    value={
                                        this.state.businessProductType || this.props.data.get('business_product_type')
                                    }
                                    style={{ width: 210 }}
                                    onChange={this.onChangeBusinessProductType}
                                >
                                    {product_type_dropdown.map((_, key) => (
                                        <Option value={_.id} key={key}>{_.value}</Option>
                                    ))}
                                </Select>
                            </Spin> 
                        {data && data.is_bnpl_case ?
                            <Spin style={{ margin: "1rem 0" }} spinning={this.state.businessProductTypeLoader}>
                                Business Product Type<Select
                                    disabled={this.props.userGroups && !this.props.userGroups.some(value => [7, 8].includes(value)) || ![4, 5, 18, 20, 7, 8].includes(this.props.stageId)}
                                    placeholder="Select Business Product Type"
                                    value={
                                        this.state.businessProductType ||
                                            ![3, 9, 8].includes(this.props.data.get('business_product_type')) ? undefined : this.props.data.get('business_product_type')
                                    }
                                    style={{ width: 210 }}
                                    onChange={this.onChangeBusinessProductType}
                                >
                                    {TL_PRODUCT_TYPE.map((_, key) => (
                                        <Option value={_} key={_}>{key}</Option>
                                    )).toList()}
                                </Select>
                            </Spin> 
                            : <div>
                                <p className="">Business Product Type:</p>
                                <label>{BUSINESS_PRODUCT_TYPE.filter(_ => _ == this.props.data.get('business_product_type'))
                                    && this.props.data.get('business_product_type')
                                    && BUSINESS_PRODUCT_TYPE.filter(_ => _ == this.props.data.get('business_product_type')).keySeq().toArray()[0] || "--"}</label>
                            </div>}
                    </Col>
                    <Col span="4">
                        {
                            <Spin style={{ margin: "1rem 0" }} spinning={this.state.programTypeLoader}>
                                Program Type<Select
                                    disabled={this.props.userGroups && !this.props.userGroups.some(value => [7, 8].includes(value)) || ![4, 5, 18, 20, 7, 8].includes(this.props.stageId)}
                                    placeholder="Select Program Type"
                                    value={
                                        this.props.data.get('program_type')
                                    }
                                    style={{ width: 210 }}
                                    onChange={this.onChangeProgramType}
                                >
                                    {PROGRAM_TYPE_NEW.map((_, key) => (
                                        <Option value={_} key={_}>{key}</Option>
                                    )).toList()}
                                </Select>
                            </Spin>}
                    </Col>
                    <Col span="4">
                                Office CPV<Select
                                    placeholder="Select Office CPV"
                                    disabled={[14,24,35,13,17].includes(this.props.stageId)} 
                                    value={
                                        CPV_STATUS.findEntry(_ => _ == this.props.data.get('office_cpv_status')) ?
                                            CPV_STATUS.findEntry(_ => _ == this.props.data.get('office_cpv_status'))[0] : undefined
                                    }
                                    style={{ width: 210 }}
                                    onChange={this.onChangeOfficeCpv}
                                >
                                    {CPV_STATUS.map((_, key) => (
                                        <Option value={_} key={_}>{key}</Option>
                                    )).toList()}
                                </Select>
                    </Col>
                    {this.props.stageId === 20 && <Col span="4">
                                FTR Category<Select
                                    placeholder="Select FTR Category"
                                    value={
                                        FTR_CATEGORY.findEntry(_ => _ == this.props.data.get('ftr_category')) ?
                                        FTR_CATEGORY.findEntry(_ => _ == this.props.data.get('ftr_category'))[0] : undefined
                                    }
                                    style={{ width: 210 }}
                                    onChange={this.onChangeftr}
                                >
                                    {FTR_CATEGORY.map((_, key) => (
                                        <Option value={_} key={_}>{key}</Option>
                                    )).toList()}
                                </Select>
                    </Col>}
                    <Col span="4">
                                <Dropdown overlay={this.generateCpvMenu()}>
                                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                    Residence CPV <Icon type="down" />
                                    </a>
                                </Dropdown>
                    </Col>
                    </Row> */}
                {/* <span className="d-flex">
                    <small>
                        {" "}
                        <i>All currencies are in INR </i>
                    </small>
                    <div className="d-flex flex-column" style={{ margin: "0 1rem" }}>
                        <div className="d-flex flex-row justify-content-space-between">
                            {data && data.perc_hold_back_less_than_10 == true &&
                                <span className="credit-limit-fields">
                                    {holdbackText}
                                </span>}
                            {data && data.industry_level_max_capping == true &&
                                <span className="credit-limit-fields">
                                    Industry level limit breach
                                </span>}
                        </div>
                        {(data && data.perc_hold_back_less_than_10 == true || data && data.industry_level_max_capping == true) &&
                            <i className="credit-limit-fields-color"> Please reach out to CRO for approval</i>}
                    </div>               
                   
                </span> */}
                {/* <Row>
                    {this.state.getBuyerExposureDataV2.length > 0 &&
                        <Col span={7}>
                            <div className="ml-05 mt-10">
                                <h3>Buyer Exposure View</h3>
                                <Table
                                    dataSource={this.state.getBuyerExposureDataV2}
                                    columns={this.columns}
                                    pagination={false}
                                    size="small"
                                    bordered
                                    className="table-bg-style"
                                /></div></Col>}
                    <Col span="1"></Col>
                    <Col span={8}>
                        {this.props.data.get('is_d2r_case' , false)  && <div className="ml-05 mt-10">
                            <h3>D2R Limit</h3>

                            <Descriptions bordered size='small' className="ant-d-desc-bg">
                            {D2R_LIMIT_COLUMNS.map(_ => <Descriptions.Item label={_.title} span="3">{formatCurrency(this.props.data.getIn(['d2r_limit' ,_.key]) , true)}</Descriptions.Item>)}
                            </Descriptions>
                        </div>}
                    </Col>
                    {this.props.stageId == AUTHORITY_APPROVAL_STAGE_ID && this.props.permissions.toJS().hasOwnProperty("appropriate_approval_edit") && this.state.approverDetails.length ? <Col span={8}>
                        <h3>Appropriate Approval</h3>
                        <div className="custom-table_static">
                        <table>
                            <thead>
                                <tr>
                                    <th>Approval From</th>
                                    <th>Is Required</th>
                                    <th>Is Approved</th>
                                    <th>Reference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.approverDetails.map((_, key) => {
                                    return <tr className="mt-10">
                                        <td>{_.name}</td>
                                        <td>{_.is_required ? "Yes" : "No"}</td>
                                        <td>{_.is_approved != null ? _.is_approved : <Select onChange={(val) => {

                                            this.setState(prevState => ({
                                                isApproved: {
                                                    ...prevState.isApproved,
                                                    [key]: val
                                                }
                                            }))
                                        }} style={{ width: 70 }}>
                                            <Option value="Approved">Yes</Option>
                                            <Option value="Rejected">No</Option>
                                        </Select>}</td>
                                        <td>{_.is_approved == null ? <Upload
                                            action={null}
                                            disabled={this.state.loading}
                                            onChange={({ file }) => {
                                                if (file.status === "uploading" && !this.state.loading) {
                                                    this.setState({
                                                        loading: true
                                                    })
                                                    message.loading("File Uploading")
                                                }
                                                if (file.status === "done") {
                                                    message.success("Successfully Approved")
                                                    this.fetchApprovalDetails();
                                                    this.setState({
                                                        loading: false
                                                    })

                                                }
                                                if (file.status === "error") {
                                                    this.setState({
                                                        loading: false
                                                    })
                                                    message.destroy();
                                                    message.error("Failed to Upload file");
                                                }

                                            }
                                            }
                                            {...{
                                                directory: false, // Upload Directory Support
                                                multiple: false, // Upload Multiple files support,
                                                action:
                                                    `${process.env.BASE_URL}/case/${this.props.caseId}/approval/by-approver/`,
                                                showUploadList: false,
                                                headers: {
                                                    Authorization: `Bearer ${getAuthToken().authToken}`
                                                },
                                                data: file => ({
                                                    document: file,
                                                    status: this.state.isApproved[key],
                                                    approver_for_email: _.email,
                                                }),
                                                // data: file => (file),

                                            }}
                                        >
                                            <Button>
                                                <Icon type="upload" /> Upload
                                            </Button>
                                        </Upload> : <Tag color="green">Uploaded</Tag>}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                        </div>
                    </Col> : <></>}
                </Row> */}
                <Modal
                    visible={this.state.isGrowthPlanModalVisible}
                    closable={true}
                    destroyOnClose={true}
                    width={"20%"}
                    footer={null}
                    onCancel={() => this.setState({ isGrowthPlanModalVisible: false })}
                >
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ width: "100%" }}>
                        <Col span={24}>
                            <label><b>AUM</b></label>
                            <Input
                                type="number"
                                placeholder="Enter AUM"
                                value={this.state.growthPlan.aum}
                                onChange={(e) => this.handleGrowthPlanChange("aum", e.target.value)}
                            />
                        </Col>
                        <Col span={24} className="mt-10">
                            <label><b>Number of RTs</b></label>
                            <Input
                                type="number"
                                placeholder="Enter RT count"
                                value={this.state.growthPlan.noOfRTs}
                                onChange={(e) => this.handleGrowthPlanChange("noOfRTs", e.target.value)}
                            />
                        </Col>
                        <Col span={24} className="mt-10">
                            <label><b>Timeline</b></label>
                            <DatePicker
                                style={{ width: "100%" }}
                                value={moment(this.state.growthPlan.timeline)}
                                disabledDate={(d) => d && d < moment().startOf("day")}
                                onChange={(date) => this.handleGrowthPlanChange("timeline", date)}
                            />
                        </Col>
                        <Row justify="end" className="mt-20">
                            <Button type="primary" onClick={this.onGrowthPlanSubmit}>
                                Save Growth Plan
                            </Button>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.isTNCCreditModalVisible}
                    closable
                    destroyOnClose
                    width="25%"
                    footer={null}
                    onCancel={() => this.setState({ isTNCCreditModalVisible: false })}
                >
                    <div className="d-flex flex-column" style={{ gap: 16 }}>
                        <label><b>Reason</b></label>
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Select Deviation Tag"
                            value={this.state.tncCredit?.deviationTag}
                            onChange={(value) =>
                                this.setState(prev => ({
                                    tncCredit: { ...prev.tncCredit, deviationTag: value }
                                }))
                            }
                        >
                            {TNCCredit.map((value, label) => (
                                <Option key={value} value={value}>
                                    {label}
                                </Option>
                            )).toList()}
                        </Select>
                        <label><b>Credit T&C</b></label>
                        <Input.TextArea
                            rows={2}
                            placeholder="Enter Credit T&C remark"
                            value={this.state.tncCredit?.creditRemark}
                            onChange={(e) => {
                                const value = e?.target?.value || "";
                                return (
                                    this.setState(prev => ({
                                        tncCredit: { ...prev.tncCredit, creditRemark: value }
                                    }))
                                )
                            }
                            }
                            disabled={!([7, 8].includes(this.props.stageId))}
                        />
                        {[11].includes(this.props.stageId) &&
                            <div className="d-flex flex-column">
                                <label className="mb-10"><b>Post Sanction Remark on T&C</b></label>
                                <Input.TextArea
                                    rows={2}
                                    placeholder="Enter Post Sanction remark"
                                    value={this.state.tncCredit?.postSanctionRemark}
                                    onChange={(e) => {
                                        const value = e?.target?.value || "";
                                        this.setState(prev => ({
                                            tncCredit: { ...prev.tncCredit, postSanctionRemark: value }
                                        }))
                                    }}
                                />
                            </div>
                        }
                        <Button
                            type="primary"
                            onClick={this.onTNCCreditSubmit}
                            className="mt-10"
                        >
                            Save
                        </Button>
                    </div>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title={"Update ASM"}
                    okText={"Update"}
                    onOk={() => this.onAsmUpdate()}
                    width={400}
                    okButtonProps={{ disabled: this.state.updateDisable }}
                    visible={this.state.asmModal} onCancel={() => this.setState({ asmModal: false, updateDisable: true })}>
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Select a person"
                        optionFilterProp="children"
                        // defaultValue={this.state.defaultAsmValue}
                        onChange={(item) => this.onAsmChange(item)}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {
                            this.props.sales_manager_users.map(item => {
                                return <Option key={item.id} value={item.id}>{item.full_name}</Option>;
                            })
                        }
                    </Select>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title={"Update Reporting Industry"}
                    okText={"Update"}
                    onOk={() => this.onIndustryUpdate()}
                    width={400}
                    okButtonProps={{ disabled: this.state.updateDisable }}
                    visible={this.state.industryModal} onCancel={() => this.setState({ industryModal: false, updateDisable: true, industryAnchorOptions: [] })}>
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder={typeof this.state.selectedIndustryVal == "string" ? this.state.selectedIndustryVal : this.props.data.getIn(['reporting_industry', 'name']) || "Select a reporting industry"}
                        optionFilterProp="children"
                        onSearch={this.onIndustryChange}
                        onChange={(value) => this.setState({ selectedIndustryVal: value, updateDisable: false })}
                        filterOption={false}
                    >
                        {this.state.industryAnchorOptions && this.state.industryAnchorOptions?.map(item => (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                        ))}
                    </Select>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title={"Update Reporting Anchor"}
                    okText={"Update"}
                    onOk={() => this.onAnchorUpdate()}
                    width={400}
                    okButtonProps={{ disabled: this.state.updateDisable }}
                    visible={this.state.anchorModal} onCancel={() => this.setState({ anchorModal: false, updateDisable: true, industryAnchorOptions: [] })}>
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder={typeof (this.state.selectedAnchorVal) == "string" ? this.state.selectedAnchorVal : this.props.data.getIn(['reporting_anchor', 'name']) || "Select a reporting anchor"}
                        optionFilterProp="children"
                        onSearch={this.onAnchorChange}
                        onChange={(value) => this.setState({ selectedAnchorVal: value, updateDisable: false })}
                        filterOption={false}
                    >
                        {this.state.industryAnchorOptions && this.state.industryAnchorOptions?.map(item => (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                        ))}
                    </Select>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title={"Update ISP"}
                    okText={"Update"}
                    onOk={() => this.onIspUpdate()}
                    width={400}
                    okButtonProps={{ disabled: this.state.updateDisable }}
                    visible={this.state.ispModal} onCancel={() => this.setState({ ispModal: false, defaultIspValue: null, updateDisable: true })}>
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Select a person"
                        optionFilterProp="children"
                        defaultValue={this.state.defaultIspValue}
                        onChange={(item) => this.onIspChange(item)}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {
                            this.props.inside_sales_persons.map(item => {
                                return <Option key={item.id} value={item.id}>{item.full_name}</Option>;
                            })
                        }
                    </Select>
                </Modal>
            </React.Fragment>
        );
    }
}

CaseDetailsSummary.propTypes = {
    companyId: PropTypes.number,
    caseId: PropTypes.number,
    seller: PropTypes.string,
    anchor: PropTypes.string,
    batch: PropTypes.string,
    bank: PropTypes.string,
    salesManager: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    product: PropTypes.string,
    stagePermissions: PropTypes.object,
    stageId: PropTypes.number,
    data: PropTypes.object,
    isInbox: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
    stageName: PropTypes.string,
    caseTaskId: PropTypes.number,
    viewCaseNotes: PropTypes.func,
    proposed_limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tenor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stop_billing_days: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scheme_roi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    anchors_list: PropTypes.array,
    sellers_list: PropTypes.array,
    casesList: PropTypes.object,
    currentCaseType: PropTypes.number,
    existing_limit: PropTypes.number,
    limit_basis_sales_display: PropTypes.number,
    parent_fi_movement_cases: PropTypes.object,
    child_fi_movement_cases: PropTypes.object,
    asm_data: PropTypes.object,
    caseDetail: PropTypes.object,
    sales_manager_users: PropTypes.array,
    callAsmList: PropTypes.func,
    permissions: PropTypes.object,
    inside_sales_persons: PropTypes.array,
    callISPList: PropTypes.func,
    isp_data: PropTypes.object,
    dbViewTableData: PropTypes.object,
    fetchCompanyDocuments: PropTypes.func,
    files: PropTypes.array,
    company: PropTypes.object,
    portfolioViewStatus: PropTypes.string,
    portfolioViewData: PropTypes.func,
    risk_sharing_percentage: PropTypes.object,
    is_high_value_case: PropTypes.bool,
};

// const NewComponent = PermissionContextManager({
//     permission: "view_case_summary_card"
// })(CaseDetailsSummary);

// export default NewComponent;

export default CaseDetailsSummary;
